import React from 'react';
import PropTypes from 'prop-types';
import { Panel, FormGroup, FormControl, Badge, Row, Col } from 'react-bootstrap';
import badgeClass from '../shared/document_badge';

export default function TemplateDefaultPages({ availablePages, templateDefaultPages }) {
  const pages = templateDefaultPages.map((id) => {
    return availablePages.find(availablePage => availablePage.id === id);
  }).filter(page => page);

  return (
    <div>
      <div className="my-3">
        <strong>Page Defaults</strong>
      </div>
      <p className="my-3">
        The pages that will populate into the "Pages" section of the document editor
      </p>

      {/* Non functional - Needed for spacing alignment */}
      <FormGroup className="search-container invisible">
        <FormControl type="text" />
      </FormGroup>

      <Panel className="overflow-auto" style={{ maxHeight: '300px' }}>
        <ul className="list-group">
          {pages.map((page, index) => (
            <li className="list-group-item" key={index}>
              <Row className="row-eq-height">
                <Col xs={5}>
                  {page.name}
                </Col>
                <Col xs={7}>
                  {page.user_label && (
                    <Badge className={`document-badge ${badgeClass('user_label')} mr-3`}>{page.user_label}</Badge>
                  )}
                  {page.size && (
                    <Badge className={`document-badge ${badgeClass('size', page.size)} mr-3`}>{page.size}</Badge>
                  )}
                </Col>
              </Row>
            </li>
          ))}
        </ul>
        {pages.length === 0 && (
          <Panel.Body>
            <div className="text-center text-muted">
              This document does not have any default pages
            </div>
          </Panel.Body>
        )}
      </Panel>
    </div>
  );
}

TemplateDefaultPages.propTypes = {
  availablePages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  })).isRequired,
  templateDefaultPages: PropTypes.arrayOf(PropTypes.number).isRequired
};

